import store from "../../app/store";
import {createAction} from "@reduxjs/toolkit";
import { DOMAIN_MANAGEMENT_API } from "../../vars";
import { showDangerToast, showSuccessToast } from "../../validation/ToastContainer";
import { securedFetch } from "../../auth/authService";
import {getSortAndFilterQueryString} from "../../view/urlService";
import {ACTION_DOMAINMANAGEMENT_CHANGED} from "../system-settings/SystemSettingsPageReducer";


export function getDomainById(id) {
    return securedFetch(`${DOMAIN_MANAGEMENT_API}/${id}`)
        .then(response => response.json())
        .then((domain) => {
            if (domain.error) {
                showDangerToast("Failed to load Domain", "Domain");
            } else {
                return domain;
            }
        })
}

//DevTeam: 20240313 -This code is calling API which will get the a setting value from the DB
export async function getSettingValue(key, type) {
    // let text = "";
    return securedFetch(`${DOMAIN_MANAGEMENT_API}/mlsetting?key=${key}&type=${type}`, null, 'GET')
    .then(response => response.json())
    .then(mlSetting => {
        return mlSetting;
    });
}

export function createDomain(data) {
    let domain = {
        id: data.id,
        name: data.name,
        kdc: data.kdc
    }

    return securedFetch(`${DOMAIN_MANAGEMENT_API}/${data.id}`, domain, 'POST'
    ).then(async response => {
        if (response.ok) {
            showSuccessToast(
                "Domain created!",
                "Domain"
            );
        } else {
            response = await response.json()
            showDangerToast(response.message, "Error")
        }
        return !!response.ok
    })
}

export function updateDomain(data) {

    let domain = {
        id: data.id,
        name: data.name,
        kdc: data.kdc
    }

    return securedFetch(`${DOMAIN_MANAGEMENT_API}`, domain, 'POST'
    ).then(async response => {
        if (response.ok) {
            showSuccessToast(
                "Domain updated!",
                "Domain"
            );
        } else {
            response = await response.json()
            showDangerToast(response.message, "Error")
        }
        return !!response.ok
    })
}

export function deleteDomain(id) {
    return securedFetch(`${DOMAIN_MANAGEMENT_API}/${id}`, null, 'DELETE')
        .then(response => response.ok);
}

export function listPageable(pageNumber, pageSize) {
    const queryString = getSortAndFilterQueryString(pageNumber, pageSize);
    return securedFetch(`${DOMAIN_MANAGEMENT_API}/page?${queryString}`).then(response => response.json()).then(data => {
        store.dispatch(createAction(ACTION_DOMAINMANAGEMENT_CHANGED)({domains: data.page}));
        return {users: data.page, totalPages: data.total, totalRecords: data.records}
    });

}




// export const restartMachineLearning = async () => {
//     return await securedFetch(`${SYSTEM_API}/restart-machinelearning`, null, 'POST'
//         ).then(async response => {
//             if (!response.ok) {
//                 const json = await response.json();
//                 showDangerToast(`${json.message || 'setting Machine Learning Training Duration was not completed'}`, `Error ${response.status}`, 'Please Contact the Administrator!')
//             } else {
//                 showSuccessToast('Setting Machine Learning Training Duration is successful', 'Machine Learning Training Duration')
//             }            
//             return response.ok;
//         })  
// }
